import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { helpers } from '@aps-management/primapp-common';

import i18n from '_utils/i18n';

import useSLotLocking from '../hooks/useSlotLocking';
import CountdownCircle from './CountdownCircle';

const LockedSlotReminderModal = ({ open, onRelease, onClose }) => {
  const currentGolf = useSelector((state) => state.app.golf);
  const courses = useSelector((state) => state.bookingData.courses);
  const lockedSlot = useSelector((state) => state.bookingData.lockedSlot);

  const { releaseSlot } = useSLotLocking();
  const [isExpired, setIsExpired] = useState(false);

  if (!lockedSlot || lockedSlot.golfId !== currentGolf.id) return null;

  const course = courses.find((c) => c.id === lockedSlot.courseId);
  if (!course) return null;

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const handleRelease = async () => {
    try {
      await releaseSlot();
      if (typeof onRelease === 'function') onRelease();
    } catch {
      // if (typeof onError === 'function') onError(); ?
      // ou dans le composant
    }
  };

  const handleExpire = () => {
    setIsExpired(true);
  };

  const dateTxt = helpers.string.ucfirst(i18n.l('date.formats.long_y', new Date(lockedSlot.date)));

  return (
    <Dialog fullWidth disableBackdropClick disableEscapeKeyDown open={open} maxWidth='xs'>
      <DialogTitle>{'Créneau déjà bloqué'}</DialogTitle>
      <DialogContent>
        <Box marginBottom={2}>
          <Typography variant='body1' align='center'>
            {course.name}
          </Typography>
          <Typography variant='body1' align='center'>
            {`${dateTxt} • ${lockedSlot.time}`}
          </Typography>
        </Box>
        <CountdownCircle
          onExpire={handleExpire}
          duration={lockedSlot.ttl}
          expiresAt={lockedSlot.expiresAt}
          timeOffset={lockedSlot.serverTimeOffset}
        />
      </DialogContent>
      <DialogActions>
        <Button color='inherit' onClick={handleClose}>
          {'Fermer'}
        </Button>
        {!isExpired && (
          <Button color='secondary' variant='contained' onClick={handleRelease}>
            {'Annuler le créneau'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default LockedSlotReminderModal;
